import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import UserDetails from './UserDetails';
import InventoryManager from './InventoryManager';
import AuctionActivity from './AuctionActivity';
import AuctionHouseDetective from './AuctionHouseDetective';
import MoaniActivity from './MoaniActivity';
import AssetActivity from './AssetActivity';
import UserStakes from './UserStakes';
import EventRewards from './EventRewards';
import RewardManager from './RewardManager';
import ErrorReports from './ErrorReports';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `user-tab-${index}`,
    'aria-controls': `user-tabpanel-${index}`,
  };
}

function UserManagement() {
  const { userId, tab } = useParams();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  // Map tab names to indices
  const tabMap = {
    'details': 0,
    'inventory': 1,
    'auction-activity': 2,
    'auction-house-detective': 3,
    'moani-activity': 4,
    'asset-activity': 5,
    'stakes': 6,
    'event-rewards': 7,
    'rewards': 8,
    'errors': 8
  };

  const tabNames = ['details', 'inventory', 'auction-activity', 'auction-house-detective', 'moani-activity', 'asset-activity', 'stakes', 'event-rewards', 'rewards', 'errors'];

  // Set tab value based on URL parameter
  useEffect(() => {
    if (tab && tabMap[tab] !== undefined) {
      setTabValue(tabMap[tab]);
    } else {
      setTabValue(0); // Default to details tab
    }
  }, [tab]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    const tabName = tabNames[newValue];
    navigate(`/user/${userId}/${tabName}`);
  };

  if (!userId) {
    return (
      <Box display="flex" justifyContent="center" mt={4} sx={{ p: 2 }}>
        <Typography variant="h6">Invalid user ID in URL.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="user management tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="User Details" {...a11yProps(0)} />
          <Tab label="Inventory" {...a11yProps(1)} />
          <Tab label="Auction Activity" {...a11yProps(2)} />
          <Tab label="Auction House Detective" {...a11yProps(3)} />
          <Tab label="MOANI Activity" {...a11yProps(4)} />
          <Tab label="Asset Activity" {...a11yProps(5)} />
          <Tab label="Stakes" {...a11yProps(6)} />
          <Tab label="Event Rewards" {...a11yProps(7)} />
          <Tab label="Add Rewards" {...a11yProps(8)} />
          <Tab label="Errors" {...a11yProps(9)} />
        </Tabs>
      </Box>
      
      <TabPanel value={tabValue} index={0}>
        <UserDetails userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <InventoryManager userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={2}>
        <AuctionActivity userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={3}>
        <AuctionHouseDetective userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={4}>
        <MoaniActivity userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={5}>
        <AssetActivity userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={6}>
        <UserStakes userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={7}>
        <EventRewards userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={8}>
        <RewardManager userId={userId} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={9}>
        <ErrorReports userId={userId} />
      </TabPanel>
    </Box>
  );
}

export default UserManagement; 